
<template>
  <div class="form-membership" style="back">
    <div class="form-wrapper">
      <!-- logo -->
      <div class="logo">
        <img src="@/assets/logo.png" alt="image" />
      </div>
      <!-- ./ logo -->
      <h5>ورود</h5>
      <!-- form -->
      <div class="pt-5" style="z-index:3;  position: absolute; text-align: center;" v-if="load">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">در حال بارگذاری ...</span>
        </div>
      </div>
      <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
        <fieldset :disabled="load">
          <div class="form-group">
            <input
              type="text"
              class="form-control text-left"
              dir="ltr"
              v-model="form.organizational_code"
              autofocus
              name="organizational_code"
              placeholder="کد سازمانی"
            />
          </div>
          <div class="text-danger text-left pb-4" v-if="form.errors.has('organizational_code')" v-text="form.errors.get('organizational_code')"></div>
          <div class="form-group">
            <input
              type="password"
              class="form-control text-left"
              placeholder="رمز عبور"
              dir="ltr"
              v-model="form.password"
              name="password"
            />
          </div>
          <div class="text-danger text-left pb-4" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></div>
          <div
            class="form-group d-sm-flex justify-content-between text-left mb-4"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                checked
                id="customCheck1"
              />
              <label class="custom-control-label" for="customCheck1"
                >به خاطر سپاری</label
              >
            </div>
          </div>
          <button class="btn btn-primary btn-block">ورود</button>
        </fieldset>
      </form>
      <!-- ./ form -->
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      load: false,
      form: new this.$form({
        organizational_code: '',
        password: '',
        ip: ''
      })
    }
  },
  mounted () {
    document.body.classList.add('form-membership')
    fetch('https://api.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => {
        this.form.ip = ip
      })
  },
  methods: {
    onSubmit () {
      window.$cookies.remove('XSRF-TOKEN')
      window.$cookies.remove('laravel_session')
      this.load = true
      // this.openNotification('top-right', 'primary')
      this.$send.submit('get', 'sanctum/csrf-cookie')
        .then(response => {
          this.$send.submit('post', 'login', this.form.data())
            .then(response2 => {
              this.form.onSuccess(response2)
              localStorage.setItem('isLoggedIn', 'true')
              this.$send.submit('get', 'api/user')
                .then(response3 => {
                  localStorage.setItem('name', response3)
                  this.$router.go({ name: 'Dashboard' })
                })
            })
            .catch(error => {
              if (typeof (error.errors) === 'undefined') {
                this.$send.submit('post', '/logout')
                  .then(response => {
                    localStorage.removeItem('isLoggedIn')
                    localStorage.removeItem('name')
                  })
                this.load = false
              } else {
                this.load = false
                this.form.onFail(error.errors)
              }
            })
        })
    }
    // openNotification (position = null, color, width = '100%') {
    //   this.$vs.notification({
    //     width,
    //     color,
    //     position,
    //     title: 'Documentation Vuesax 4.0+',
    //     text: `These documents refer to the latest version of vuesax (4.0+),
    //     to see the documents of the previous versions you can do it here 👉 Vuesax3.x`
    //   })
    // }
  }
}
</script>
